var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNplFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.571 44.429h33.293L12.076 22.333l22.614.026L.58.571V44.43H.571Z",
    fill: "#CE0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.026-.536 36.77 22.968l-23.243-.027 21.787 22.094H.571v-.606h-.597V-.536Zm1.213 44.358h31.228l-21.79-22.097 21.986.025L1.187 1.678v42.144Z",
    fill: "#000063"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.882 32.678-2.373.79 1.863 1.741-2.505-.158 1.028 2.302-2.24-1.08.043 2.513-1.652-1.837-.94 2.338-.81-2.311-1.783 1.81.158-2.434-2.364 1.002 1.107-2.198-2.575.053 1.89-1.608-2.4-.923 2.373-.791-1.872-1.74 2.496.158-1.02-2.303 2.25 1.081-.043-2.514 1.652 1.837.94-2.338.8 2.312 1.793-1.81-.167 2.434 2.373-1.002-1.116 2.197 2.584-.053-1.89 1.609 2.4.923Zm-2.848-16.234-.993.739.492.404a8.243 8.243 0 0 0 2.698-3.164c.159 1.872-1.555 6.064-6.038 6.108a6.206 6.206 0 0 1-6.284-6.178c.88 1.6 1.424 2.373 2.813 3.208l.413-.387-.932-.782 1.204-.317-.65-1.09 1.265.088-.158-1.265 1.108.65.351-1.187.791.95.747-.906.405 1.23 1.037-.72-.132 1.257 1.248-.15-.589 1.16 1.204.352Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNplFlag);
export default __webpack_public_path__ + "static/media/npl-flag.738e34d81ffd8f20cf1c9be8a6a9fe24.svg";
export { ForwardRef as ReactComponent };